import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  modifyModalRecoil,
  userDivisionAddModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import { hangjungdong } from '@/data/hangjungdong';
import { UserTypeApi } from '@/sdk/UserTypeApi';
import {
  CreateUserTypeDtoTx,
  UserTypeControllerCheckUserTypeParams,
} from '@/sdk/data-contracts';
import {
  userListRecoil,
  userTypesRecoil,
  userSitesRecoil,
} from '@/atom/UserAtom';

const UserDivisionAddModal = () => {
  const userTypeApi = new UserTypeApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setUserDivisionAddModalState = useSetRecoilState(
    userDivisionAddModalRecoil,
  );

  const [type, setType] = useState<string>('');
  const [typeDuplication, setTypeDuplication] = useState<boolean>(false);
  const [description, setDescription] = useState<string>('');

  const handleTypeDuplication = async () => {
    if (type.trim() === '') {
      setErrorModalText('회원 구분을 입력해 주세요.');
      return;
    }

    const dto: UserTypeControllerCheckUserTypeParams = {
      type,
    };

    try {
      const { data } = await userTypeApi.userTypeControllerCheckUserType(dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      if (data.message === '이미 등록된 회원 구분입니다.') {
        setErrorModalText('중복된 회원 구분입니다.');
        return;
      }
      setTypeDuplication(true);
    } catch (err: any) {}
  };

  const handleSubmit = async () => {
    if (!typeDuplication) {
      setErrorModalText('회원 구분 중복 확인을 해주세요.');
      return;
    }

    const dto: CreateUserTypeDtoTx = {
      type,
      description,
    };

    try {
      await userTypeApi.userTypeControllerCreateUserType(dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setCompleteModalState(true);
    } catch (err: any) {}
  };

  return (
    <>
      <ModalType1 width={560}>
        <div className="title-box flex aic jcsb">
          <h1>회원 구분 등록</h1>
          <button
            className="x-btn img-box"
            onClick={() => setUserDivisionAddModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">기본 정보</h2>
                </div>
                <div className="right-box flex">
                  <h3>
                    <span className="inblock">*</span>필수 항목
                  </h3>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th>
                        회원구분<span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <div className="td-box">
                          <IS.TextInputType1
                            style={{ width: 190 }}
                            type="text"
                            value={type}
                            onChange={(e) => {
                              setType(e.target.value);
                              setTypeDuplication(false);
                            }}
                          />
                          <BS.Btn3Type3
                            type="button"
                            onClick={handleTypeDuplication}
                            disabled={typeDuplication}
                          >
                            {typeDuplication ? '완료' : '중복 조회'}
                          </BS.Btn3Type3>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>설명</th>
                      <td colSpan={3}>
                        <IS.TextInputType1
                          style={{ width: 388 }}
                          type="text"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setUserDivisionAddModalState(false)}
            >
              취소
            </BS.Btn2Type3>
            <BS.Btn2Type4 type="button" onClick={handleSubmit}>
              등록
            </BS.Btn2Type4>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default UserDivisionAddModal;
